import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { Data } from "./DataService";
import { PreLoginService } from "./pre-login/pre-login.service";
import { ServiceStock } from "./service-stock.service";

import { UserService } from "./user.service";

@Injectable()
export class HttpResponseInceptor implements HttpInterceptor {
    constructor(protected _userService: UserService,private _preLoginService : PreLoginService,private dataStore: Data, private _router : Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(

            map((event: HttpEvent<any>) => {
                // if (!this._userDetails.token) {
                //   this._router.navigate
                // }
                return event;

            }),
            catchError((err: HttpErrorResponse): Observable<any> => {
                if (err instanceof HttpErrorResponse && err.status == 401) {
                    this.dataStore.setData('LOGOUT_INFO', {
                        status: 'F',
                        message: "Unauthorized Access"
                    });
                    this._preLoginService.refreshTokenService?.stop();
                }else if (err instanceof HttpErrorResponse && err.status == 502){
                    // this.logout();
                }
                return throwError(err);
            }));
    }

    logout(){
        this._preLoginService.refreshTokenService?.stop();
        this._userService.clearSession();
    }
}
